import { TApplicationState } from '../../types/redux';

export const getIsCompareFlightTooltipShow = (state: TApplicationState) =>
  state.compareFlightTooltip.isCompareFlightTooltipShow;
